import $ from 'jquery';
import { fabric } from 'fabric';
import { getState, modifyState } from '~src/state';
import { requestMagicEraser, stopMagicEraser } from '~core/magicEraser';
import { createUploaderInstance, onErrorAttachment } from '~uploader';

export const initMagicEraser = () => {
  const initialBrushRadius = 30;

  createUploaderInstance({
    alias: 'magiceraser',
    dir: 'magiceraser',
    bucket: 'magiceraser',
    onComplete: () => {},
    onError: onErrorAttachment,
    pluginDashboard: {},
  });

  const defaultMouseCursor = new fabric.Circle({
    left: -1000,
    top: -1000,
    radius: initialBrushRadius,
    fill: 'rgba(155, 246, 57, 0.5)',
    stroke: 'rgba(0, 0, 0, 0.5)',
    originX: 'center',
    originY: 'center',
    scaleX: 1,
    scaleY: 1,
    visible: true,
  });

  const mouseCursor = getState('mouseCursorMagicEraser', defaultMouseCursor);
  modifyState('mouseCursorMagicEraser', mouseCursor);
  modifyState('magicEraserBrushRadius', initialBrushRadius);

  $('#editor-image-magic-eraser-radius-slider').val(initialBrushRadius);

  $('body').off('input', '#editor-image-magic-eraser-radius-slider');
  $('body').on('input', '#editor-image-magic-eraser-radius-slider', () => {
    const brushRadius = $('#editor-image-magic-eraser-radius-slider').val();
    modifyState('magicEraserBrushRadius', brushRadius);
  });

  $('body').off('mouseleave', '#magic-eraser-container');
  $('body').on('mouseleave', '#magic-eraser-container', () => {
    const isMagicEraserActive = getState('isMagicEraserActive');
    if (!isMagicEraserActive) {
      return;
    }

    mouseCursor.set('visible', false);
    window.magicEraserDrawingCanvas.renderAll();
  });

  $('body').off('mouseenter', '#magic-eraser-container');
  $('body').on('mouseenter', '#magic-eraser-container', () => {
    const isMagicEraserActive = getState('isMagicEraserActive');
    if (!isMagicEraserActive) {
      return;
    }

    mouseCursor.set('visible', true);
    window.magicEraserDrawingCanvas.renderAll();
  });

  $('body').off('click', '#editor-menu-run-magic-eraser');
  $('body').on('click', '#editor-menu-run-magic-eraser', () => {
    requestMagicEraser();
  });

  // Deprecated: Apply magic eraser button - now auto-applies after API response
  // $('body').off('click', '#editor-menu-apply-magic-eraser');
  // $('body').on('click', '#editor-menu-apply-magic-eraser', () => {
  //   applyMagicEraser();
  // });

  $('body').off('click', '#editor-menu-abort-magic-eraser');
  $('body').on('click', '#editor-menu-abort-magic-eraser', () => {
    stopMagicEraser();
  });

  window.magicEraserDrawingCanvas.add(mouseCursor);

  window.magicEraserDrawingCanvas.freeDrawingBrush.color =
    'rgba(155, 246, 57, 0.8)';
  window.magicEraserDrawingCanvas.freeDrawingBrush.width =
    initialBrushRadius * 2;

  window.magicEraserDrawingCanvas.on('mouse:move', function (evt) {
    const mouse = this.getPointer(evt.e);
    const mouseCursor = getState('mouseCursorMagicEraser');
    if (!mouseCursor) {
      console.error('Undefined mouseCursor');
      return;
    }
    mouseCursor
      .set({
        top: mouse.y,
        left: mouse.x,
        visible: true,
      })
      .setCoords();

    window.magicEraserDrawingCanvas.requestRenderAll();
  });

  window.magicEraserDrawingCanvas.on('object:added', function (event) {
    if (event.target && event.target.type === 'path') {
      setTimeout(() => {
        event.target.clone((clonedTarget) => {
          clonedTarget.set('stroke', '#ffffff');
          window.magicEraserManipulationCanvas.add(clonedTarget);
          clonedTarget.bringToFront();
          window.magicEraserManipulationCanvas.requestRenderAll();
          $('#editor-menu-run-magic-eraser').attr('disabled', false);
        });
      }, 10);
    }
  });
};
